import { Component, OnInit,Input } from '@angular/core';

@Component({
  selector: 'app-donation-details',
  templateUrl: './donation-details.component.html',
  styleUrls: ['./donation-details.component.less']
})
export class DonationDetailsComponent implements OnInit {

  @Input('details') details: any;

  constructor() { }

  ngOnInit() {
  }

}
